export const getText = (detail) => {
  if (detail) {
    return "Inicio";
  } else {
    return "Volver";
  }
};
